import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import "./gutschein.css";
// import myVideo from "../../assets/video.mp4";

export default function GutscheinGeneratorInvisible() {
	const pdfRef = useRef();

	const [name, setName] = useState("");
	const [date, setDate] = useState(() => {
		const now = new Date();
		return now.toLocaleDateString("de-DE");
	});
	const [pilot, setPilot] = useState("Semir Hamidovic");
	const [email, setEmail] = useState("");
	const [showButtons, setShowButtons] = useState(false);
	const [response, setResponse] = useState("");
	const [loading, setLoading] = useState(false);
	const [amount, setAmount] = useState();
	const [selected, setSelected] = useState(null);
	const handleSubmit = e => {
		e.preventDefault();
		if (!name || !email || !amount) {
			setResponse("Bitte alle Felder ausfüllen ! (Name,Email,Flugzeit)");
			return;
		}
		setResponse("");
		setShowButtons(true);
	};

	const createOrder = async () => {
		try {
			const res = await axios.post("/api/create-order", {
				name,
				email,
				amount,
			});
			return res.data.id;
		} catch (err) {
			console.error(err);
			setResponse("Fehler beim Erstellen der Bestellung");
		}
	};

	const generatePdfBase64 = async () => {
		const canvas = await html2canvas(pdfRef.current, { scale: 2 });
		const imgData = canvas.toDataURL("image/png");
		const pdf = new jsPDF("p", "mm", "a4");
		const width = pdf.internal.pageSize.getWidth();
		const height = (canvas.height * width) / canvas.width;
		pdf.addImage(imgData, "PNG", 0, 0, width, height);
		return pdf.output("datauristring");
	};

	const onApprove = async (data, actions) => {
		try {
			const capture = await actions.order.capture();

			setResponse("Zahlung erfolgreich! Gutschein wird versendet...");
			const pdfBase64 = await generatePdfBase64();

			await axios.post("/send-email", {
				name,
				email,
				subject: "Ihr Motorschirm-Gutschein",
				html: `<div style="font-family: Arial, sans-serif; max-width: 500px; margin: auto; 
                border: 1px solid #ddd; border-radius: 10px; overflow: hidden;">
  
  
                <div style="background: linear-gradient(135deg, #007bff, #00aaff); 
                    padding: 18px; text-align: center; color: white;">
                    <h2 style="margin: 0; font-size: 26px;">🎁 Ihr Rundflug-Gutschein</h2>
                </div>

  
                <div style="padding: 20px;">

                    <p style="font-size: 16px; color: #333; margin-bottom: 10px;">
                    <strong>Name:</strong> ${name}
                    </p>

                    <p style="font-size: 16px; color: #333; margin-bottom: 10px;">
                    <strong>Datum:</strong> ${date}
                    </p>

                    <p style="font-size: 16px; color: #333; margin-bottom: 20px;">
                    <strong>Pilot:</strong> ${pilot}
                    </p>

                    
                    <div style="padding: 15px; background: #f5f9ff; border-left: 4px solid #007bff;
                        border-radius: 5px; margin-top: 15px;">
                    <p style="margin: 0; font-size: 15px;">
                        Dieser Gutschein berechtigt zu einem <strong>Motorschirm-Rundflug</strong>.
                        Der genaue Flugtermin wird individuell vereinbart.
                    </p>
                    </div>

                </div>

  
                <div style="background: #f5f5f5; text-align: center; padding: 10px; 
                    font-size: 12px; color: #777;">
                    © Motorschirm Rundflüge – Becherbach Flugplatz
                </div>

                </div>
                `,
				attachment: pdfBase64,
				filename: "gutschein.pdf",
			});

			setResponse("Email mit Gutschein erfolgreich versendet!");
		} catch (err) {
			console.error(err);
			setResponse("Fehler bei der Zahlung oder beim Versand des Gutscheins.");
		} finally {
			setShowButtons(false);
		}
	};
	console.log("amount", amount);

	return (
		<div className='gutschein-container'>
			<div className='videoWrapper'>
				<h1>Der Vorgeschmack</h1>
				<video width='100%' controls>
					<source src='/video/video.mp4' type='video/mp4' />
					Dein Browser unterstützt das Video-Tag nicht.
				</video>
			</div>
			{!showButtons && (
				<form onSubmit={handleSubmit}>
					<div className='flightTimeWrapper'>
						<div className='flightTime'>
							<div
								onClick={() => {
									setAmount(169);
									setSelected(169);
								}}
								className={`thrity ${selected === 169 ? "active" : ""}`}>
								<div className='thrityHeader'>
									<h3>Rundflug 30</h3>
								</div>
								<div className='check'>
									<h2>169 €</h2>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>30 Min Flugzeit</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Treffen am Flugplatz</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Besprechnung im Team</p>
									</div>
									<div className='border'></div>
								</div>
							</div>
							<div
								onClick={() => {
									setAmount(199);
									setSelected(199);
								}}
								className={`thrity ${selected === 199 ? "active" : ""}`}>
								<div className='thrityHeader'>
									<h3>Rundflug 45</h3>
								</div>
								<div className='check'>
									<h2>199 €</h2>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>45 Min Flugzeit</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Treffen am Flugplatz</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Besprechnung im Team</p>
									</div>
									<div className='border'></div>
								</div>
							</div>
							<div
								onClick={() => {
									setAmount(239);
									setSelected(239);
								}}
								className={`thrity ${selected === 239 ? "active" : ""}`}>
								<div className='thrityHeader'>
									<h3>Rundflug 60</h3>
								</div>
								<div className='check'>
									<h2>239 €</h2>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>60 Min Flugzeit</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Treffen am Flugplatz</p>
									</div>
									<div className='border'></div>
									<div>
										<img src='./img/paypal/check.png' alt='check' />{" "}
										<p>Besprechnung im Team</p>
									</div>
									<div className='border'></div>
								</div>
							</div>
						</div>
					</div>

					<input
						value={name}
						onChange={e => setName(e.target.value)}
						placeholder='Name der Person'
						className='gutschein-input'
					/>

					<input
						value={email}
						onChange={e => setEmail(e.target.value)}
						placeholder='Email'
						className='gutschein-input'
					/>
					<button type='submit' className='gutschein-button'>
						Weiter zur Zahlung
					</button>
				</form>
			)}

			{showButtons && (
				<PayPalScriptProvider
					options={{
						"client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
						currency: "EUR",
					}}>
					{loading ? (
						<p>
							Die Zahlung wird verarbeitet und der Gutschein wird versendet...
						</p>
					) : (
						<div className='paypalWrapper'>
							<PayPalButtons
								createOrder={createOrder}
								onApprove={onApprove}
								style={{ layout: "vertical" }}
							/>
						</div>
					)}
				</PayPalScriptProvider>
			)}

			{response && (
				<p
					style={{
						textAlign: "center",
						margin: "20px auto",
						padding: "15px 20px",
						backgroundColor: "rgba(0, 0, 0, 0.1)",
						color: "white",
						borderRadius: "8px",
						boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
						lineHeight: "1.5",
						fontSize: "20px",
						maxWidth: "600px",
					}}>
					{response}
				</p>
			)}

			{/* Unsichtbare Gutschein-Vorlage */}
			<div ref={pdfRef} className='gutschein-hidden'>
				<div
					style={{
						position: "absolute",
						left: "-9999px",
						top: 0,
						width: "100%",
						maxWidth: "600px",
						margin: "0 auto",
						padding: "20px",
						fontFamily: "Arial, sans-serif",
						borderRadius: "12px",
						background: "#f7f7f7",
						border: "2px solid #ddd",
					}}>
					<h2
						style={{
							textAlign: "center",
							color: "#1a73e8",
							marginBottom: "20px",
						}}>
						Ihr Rundflug-Gutschein
					</h2>

					<div
						style={{
							background: "white",
							padding: "15px 20px",
							borderRadius: "10px",
							border: "1px solid #eaeaea",
							fontSize: "16px",
							lineHeight: "1.6",
						}}>
						<p>
							<strong>Name:</strong> {name}
						</p>
						<p>
							<strong>Datum:</strong> {date}
						</p>
						<p>
							<strong>Pilot:</strong> {pilot}
						</p>
						{/* <p>
							<strong>Flugzeit:</strong> {time}
						</p> */}
						<p>
							<strong>Preis:</strong> {amount} €
						</p>
					</div>

					<p
						style={{
							marginTop: "20px",
							textAlign: "center",
							fontSize: "14px",
							color: "#888",
						}}>
						Vielen Dank für Ihre Buchung!
					</p>
				</div>
			</div>
		</div>
	);
}
